import React from 'react';

import Text from '@pray/shared/components/ui/Text';

import type { CheckoutHeaderProps } from '../types';

import styles from './CheckoutHeader.module.scss';

export default function CheckoutHeader({ title, subtitle, children }: CheckoutHeaderProps) {
  return (
    <div className={styles.header}>
      <Text className={styles.title}>{title}</Text>
      {subtitle && <Text className={styles.subtitle}>{subtitle}</Text>}
      {children}
    </div>
  );
}
